import React from "react";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import styles from "../authorization.module.scss";
import { EmailIcon } from "../AuthIcons";

const cx = classNames.bind(styles);

interface ForgotPasswordViewProps {
  email: string;
  emailError: boolean;
  authError: string | null;
  isLoading: boolean;
  onEmailChange: (value: string) => void;
  onBackToSignIn: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

export const ForgotPasswordView: React.FC<ForgotPasswordViewProps> = ({
  email,
  emailError,
  authError,
  isLoading,
  onEmailChange,
  onBackToSignIn,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <form className={cx('form')} onSubmit={onSubmit}>
      <div className={cx('formHeader')}>
        <h2 className={cx('formTitle')}>{t("resetPassword")}</h2>
        <p className={cx('formSubtitle')}>{t("enterEmailForReset")}</p>
      </div>

      {authError && <div className={cx('errorMessage')}>{t(authError)}</div>}

      <div className={cx('inputGroup')}>
        <label className={cx('inputLabel')}>{t("email")}</label>
        <div className={cx('inputWrapper', { inputError: emailError })}>
          <div className={cx('inputIcon')}>
            <EmailIcon />
          </div>
          <input
            name="email"
            type="email"
            className={cx('input')}
            placeholder={t("enterEmail")}
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
          />
        </div>
        {emailError && <span className={cx('inputErrorText')}>{t("enterEmail")}</span>}
      </div>

      <button type="submit" className={cx('submitButton')} disabled={isLoading}>
        {isLoading ? <span className={cx('spinner')}></span> : t("sendResetCode")}
      </button>

      <div className={cx('formFooter')}>
        <button
          type="button"
          onClick={onBackToSignIn}
          className={cx('backButton')}
        >
          &larr; {t("backToSignIn")}
        </button>
      </div>
    </form>
  );
};
